var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacistCaption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4187 71.0608H26.5625C19.9841 71.0608 14.6328 65.7661 14.6328 59.2583V35.99C14.6328 29.4822 19.9841 24.1875 26.5625 24.1875H55.4187C61.9971 24.1875 67.3484 29.4822 67.3484 35.99V44.6533H61.3427V35.99C61.3427 32.7582 58.6853 30.1292 55.4187 30.1292H26.5625C23.2958 30.1292 20.6384 32.7583 20.6384 35.99V59.2582C20.6384 62.49 23.2958 65.119 26.5625 65.119H55.4187C58.6853 65.119 61.3427 62.49 61.3427 59.2582V50.595H67.3484V59.2582C67.3484 65.7661 61.9971 71.0608 55.4187 71.0608Z",
    fill: "#587E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0297 56.536H32.2934C27.3334 56.536 23.3125 52.5579 23.3125 47.6506V47.5971C23.3125 42.6894 27.3337 38.7109 32.2941 38.7109H49.0304C53.9904 38.7109 58.0114 42.6891 58.0114 47.5964V47.6499C58.0114 52.5575 53.9902 56.536 49.0297 56.536ZM29.3181 47.5591V47.688C29.3181 49.2931 30.6333 50.5944 32.2557 50.5944H49.0682C50.6906 50.5944 52.0058 49.2931 52.0058 47.688V47.5591C52.0058 45.9539 50.6906 44.6527 49.0682 44.6527H32.2557C30.6333 44.6527 29.3181 45.9539 29.3181 47.5591Z",
    fill: "#A9CF3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9899 38.7109H37.9844V56.536H43.9899V38.7109Z",
    fill: "#587E85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6704 22.8639H24.6406V9H56.6704V22.8639ZM30.6462 16.9223H50.6647V14.9417H30.6462V16.9223Z",
    fill: "#587E85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0011 30.1256H31.9844V16.9219H50.0011V30.1256ZM37.9899 24.1839H43.9955V22.8635H37.9899V24.1839Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacistCaption);
export default __webpack_public_path__ + "static/media/pharmacist-caption.9a20de2e984863d057bc1cd9c792833b.svg";
export { ForwardRef as ReactComponent };